export enum BooleanType {
    No = 0,
    Yes = 1
}
